import { WAIVED_INTEREST } from '../const/conditions';
import PRODUCT_TYPE from '../const/productType';
export const isPN4 = (productType) => {
    return productType === PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR;
};
export const isMonthly = (productType) => {
    return productType === PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY;
};
export const isWaivedInterestEnrolled = (productType, enrollments) => {
    return (productType === PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY &&
        (enrollments === null || enrollments === void 0 ? void 0 : enrollments.includes(WAIVED_INTEREST)));
};
export const isSetpayLegacyProduct = (productType) => {
    return productType === PRODUCT_TYPE.INSTALLMENT_LOAN;
};
export const isPayLaterProduct = (productType) => {
    const payLaterProducts = [
        PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY,
        PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR
    ];
    return payLaterProducts.includes(productType);
};
export const isInstallmentLoan = (productType) => {
    const installmentLoanProducts = [
        PRODUCT_TYPE.INSTALLMENT_LOAN,
        PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY,
        PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR,
        PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED
    ];
    return installmentLoanProducts.includes(productType);
};
export const isRevolvingCreditProduct = (productType) => !isInstallmentLoan(productType);
export const isSecuredInstallmentLoanProduct = (productType) => productType === PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED;
